export enum ConfirmationType {
    Quick = 'quick',
    Long = 'long',
    Cancel = 'cancel',
}
export enum ConfirmationTypeSize {
    M = 'm',
    L = 'l',
    Xl = 'xl'
}
